import ModalVerificationRegister from './ModalVerificationRegister';

export default ModalVerificationRegister;
